const WPAPI = {
  allPosts: "http://juha.blog/wp-json/wp/v2/posts",
  books: "http://juha.blog/wp-json/wp/v2/posts?categories=23&per_page=4",
};
export default WPAPI;
